import { render } from "./kalio-text-list-input.vue?vue&type=template&id=629b24c2"
import script from "./kalio-text-list-input.vue?vue&type=script&lang=js"
export * from "./kalio-text-list-input.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__